import type { StateCreator } from 'zustand'

import { type LifeState, INITIAL_STATE } from './types'

const createLifeSlice: StateCreator<LifeState, [], [], LifeState> = (set) => ({
  life: INITIAL_STATE,
  setLifeObject: (life) => set(() => ({ life })),

  setLifeCancellation: (lifeCancellation) =>
    set((state) => ({
      life: {
        ...state.life,
        cancellation: {
          ...state.life.cancellation,
          cancellation: lifeCancellation,
        },
      },
    })),

  setLifeCancellationReasonCode: (cancellationReasonCode) =>
    set((state) => ({
      life: {
        ...state.life,
        cancellation: {
          ...state.life.cancellation,
          reasonCode: cancellationReasonCode,
        },
      },
    })),

  setLifeCancellationReasons: (cancellationReasons) =>
    set((state) => ({
      life: {
        ...state.life,
        cancellation: {
          ...state.life.cancellation,
          reasons: cancellationReasons,
        },
      },
    })),

  setLifeCancellationTerms: (isTermsAndConditionsAccepted) =>
    set((state) => ({
      life: {
        ...state.life,
        cancellation: {
          ...state.life.cancellation,
          isTermsAndConditionsAccepted,
        },
      },
    })),

  setLifeCancellationReceipt: (receipt) =>
    set((state) => ({
      life: {
        ...state.life,
        cancellation: { ...state.life.cancellation, receipt },
      },
    })),

  resetLife: () => set(() => ({ life: INITIAL_STATE })),
})

export default createLifeSlice
